import { Button, mergeClasses } from "@fluentui/react-components";
import { Add20Regular } from "@fluentui/react-icons";
import { useSharedButtonStyles } from "theme/sharedStyles";

import { useStyles } from "./WorkspaceEmptyState.styles";
import { IWorkspaceEmptyStateProps } from "./WorkspaceEmptyState.types";

export const WorkspaceEmptyState = ({
  onCreateWorkspace,
}: IWorkspaceEmptyStateProps): JSX.Element => {
  const styles = useStyles();
  const buttonStyles = useSharedButtonStyles();

  return (
    <div className={styles.root}>
      <h1 className={styles.wordmark} aria-label="Project IQ">
        <span className={styles.wordmarkProject}>Project </span>
        <span className={styles.wordmarkIq}>IQ</span>
      </h1>

      <h2 className={styles.subheading}>Select a workspace</h2>

      <p className={styles.body}>
        Choose a workspace from the left to open its canvas — or start a new one
        to get going.
      </p>

      <Button
        className={mergeClasses(buttonStyles.primaryButton, styles.ctaButton)}
        icon={<Add20Regular />}
        onClick={onCreateWorkspace}
        aria-label="Create a Workspace"
      >
        Create a Workspace
      </Button>
    </div>
  );
};
